<script lang="ts">
	import { type SelectOption } from '../select/selectOption'
	import { createBubbler, stopPropagation } from 'svelte/legacy'

	const bubble = createBubbler()

	interface Props {
		options: SelectOption[]
		group?: string[] | null
		required?: boolean
		name?: string
		small?: boolean
		smallText?: boolean
		full?: boolean
		loading?: boolean
		id?: string
		indeterminate?: boolean
		hideLabel?: boolean
		class?: string | null
	}

	let {
		options,
		group = $bindable(null),
		required = false,
		name = '',
		small = false,
		smallText = false,
		full = false,
		loading = false,
		id = null,
		indeterminate = false,
		hideLabel = false,
		class: className = null,
	}: Props = $props()
</script>

<div class="flex flex-col gap-2">
	{#each options as option (option.value)}
		<label
			class="
        cursor-pointer items-center text-base whitespace-nowrap
        {full ? 'flex w-full' : 'inline-flex'}
        {className}
      "
			class:text-xs={smallText}
		>
			<input
				{id}
				{name}
				class="
          hover:bg-primary-500/10 form-checkbox text-primary-500 hover:border-primary-500 checked:hover:bg-primary-400 focus-visible:ring-primary-600 cursor-pointer rounded border border-gray-400 bg-transparent hover:border-2 focus:ring-transparent focus-visible:ring-2
          {hideLabel ? '' : small ? 'mr-3' : 'mr-4'}
          {small ? 'h-5 w-5' : 'h-7 w-7'}
        "
				class:animate-pulse={loading}
				{indeterminate}
				onchange={bubble('change')}
				onclick={stopPropagation(bubble('click'))}
				{required}
				type="checkbox"
				value={option.value}
				bind:group
			/>
			{option.label}
		</label>
	{/each}
</div>
